import { Component, OnInit, ViewEncapsulation, ViewChild, AfterViewInit } from '@angular/core';
import { NgClass } from '@angular/common';
import { FormGroup, FormBuilder, Validators } from '../../../../node_modules/@angular/forms';
import { DynamicFormComponent } from '../../shared/dynamicform/dynamic-form/dynamic-form.component';
import { FieldConfig } from '../../shared/dynamicform/models/field-config.interface';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { HttpRequestService } from 'src/app/shared/services/http-request.service';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';
import { AzureInfoService } from 'src/app/msal-module/azure-info.service';
import { ConfigService } from 'src/app/config.service';
import { CommonService } from '../../shared/services/common.service';
import { CSharpRequestService } from 'src/app/shared/services/csharp-request.service';
import { AdDataModel, AzureAdModel, intialAdDataModel, OAuthSettingsConfig, TenantInformation } from 'src/app/msal-module/azure-ad.interface';
import * as MasterData from '../../../assets/json/azure-config.json';
import { ToastMessageComponent } from '../../shared/toast-message/toast-message.component';
import { PopupComponent } from '../../shared/popup/popup.component';
import * as appApiResources from '../../shared/globalcontants';
import * as myGlobals from '../../shared/globalcontants';

@Component({
    selector: 'app-setting-config',
    templateUrl: './settings-configuration.component.html',
    styleUrls: ['./settings-configuration.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, DynamicFormComponent, ToastMessageComponent],
    standalone: true
})

export class SettingsConfigurationComponent implements OnInit, AfterViewInit {
  @ViewChild(DynamicFormComponent) formSetting: DynamicFormComponent;
  
  public config: FieldConfig[];
  public settingDetails: any;
  public toastShow = false;
  public toastMessage: string = '';
  public buttonDisable = true;
  
  private isAdUser: boolean;
  private adDataInfo: any;
  private adTenantName: string;
  constructor(
    private _cs: CommonService,
    private fb: FormBuilder,
    public router: Router,
    public dialog: MatDialog,
    private _ts: TranslateService,
    private _http: HttpRequestService,
    private sessionStorage: SessionStorageService,
    private AzureInfo: AzureInfoService,
    private azureConfig: ConfigService,
    private csharpService: CSharpRequestService
  ) {
    this.adDataInfo = this.azureConfig.getSettings('AdData');
    this.adTenantName = this.azureConfig.getSettings().TenantIdentifier;
    this.isAdUser = (this.adDataInfo && this.adDataInfo.IsAdEnabled) ? true : false;

    this.settingDetails = this._ts.instant('setting');
    const localTenantName = localStorage.getItem('tenant');
    this.config = [
      {
        type: 'input',
        label: this.settingDetails.apiUrl,
        name: 'apiUrl',
        placeholder: this.settingDetails.apiUrl,
        validation: [Validators.compose([Validators.required, Validators.minLength(1)])],
        autocomplete: 'on',
        value: localStorage.getItem('apiUrl')
      },
      {
        type: 'input',
        label: this.settingDetails.tenant,
        name: 'tenant',
        placeholder: this.settingDetails.tenant,
        validation: [Validators.compose([Validators.required, Validators.minLength(1)])],
        autocomplete: 'on',
        disabled: this.isAdUser ? true : false,
        value: (localTenantName !== null && localTenantName !== "null" && localTenantName !== undefined) ? localTenantName : this.adTenantName
      },
      {
        type: 'button',
        label: this.settingDetails.update,
        name: 'button',
        class: 'large-button-mobile-confirm confirm-button settings-configuration-button',
        disabled: this.buttonDisable
      }
    ];
  }

  ngOnInit() {
    this._cs.showAppHeaderChange.next(true);
  }

  navigateToLogin() {
    this.router.navigate(['/login']);
  }

  ngAfterViewInit(): void {
    this.formSetting.form.get('apiUrl').valueChanges.subscribe(x => {
      const apiUrlHasValue = x && x.length > 0;
      const tenantHasValue = this.formSetting.form.get('tenant').value && this.formSetting.form.get('tenant').value.length > 0;
      this.formSetting.config.find(filterx => filterx.type === 'button').disabled = !(apiUrlHasValue && tenantHasValue);
    });

    this.formSetting.form.get('tenant').valueChanges.subscribe(x => {
      const tenantHasValue = x && x.length > 0;
      const apiUrlHasValue = this.formSetting.form.get('apiUrl').value && this.formSetting.form.get('apiUrl').value.length > 0;
      this.formSetting.config.find(filterx => filterx.type === 'button').disabled = !(apiUrlHasValue && tenantHasValue);
    });
  }

  async submit($event: any) {
    const that = this;
    if (this.formSetting.form.valid) {
      const formDetails = this.formSetting.value;
      const dialogArray = {
        headerText: this.settingDetails.alert,
        contentText: this.settingDetails.alertmsg,
        cancelText: this._ts.instant('common.cancel'),
        confirmText: this._ts.instant('common.ok'),
        confirmHelpText: 'OK',
        cancelHelpText: 'CANCEL'
      };

      this._cs.mobilePopUpProperty.data = dialogArray;
      const dialogRef = this.dialog.open(PopupComponent, this._cs.mobilePopUpProperty);

      dialogRef.afterClosed().subscribe(async (result) => {
        if (result) {
          switch (result) {
            case 'OK':
              const tenantName = (formDetails && formDetails.tenant !== undefined) ? formDetails.tenant : localStorage.getItem('tenant');
              localStorage.setItem('apiUrl', formDetails.apiUrl);
              const EndpointUrl = `/tenantservice/api/TenantService/tenants?tenantIdentifier=${tenantName.toLowerCase()}`;
              
              try {
                const response = await this._http.GetHttpRequest(EndpointUrl).toPromise();
                let getTenantInfo = null;
                
                if (response && typeof response === 'string' && response.trim() !== '') {
                  getTenantInfo = JSON.parse(response);
                }

                if (getTenantInfo) {
                  if (getTenantInfo?.adData != null && !this.isAdUser) {
                    that.showToastMessage(this._ts.instant("common.Switching Tenant") + " (" + formDetails.tenant + ") " + this._ts.instant("common.not applicable"));
                  } else {
                    const adModelObject: AdDataModel = (getTenantInfo.hasOwnProperty('adData') && getTenantInfo?.AdData !== null) ?
                      JSON.parse(getTenantInfo.adData) : intialAdDataModel;
                    
                    localStorage.setItem('tenant', tenantName);
                    const IsRgueset = false;
                    this.sessionStorage.localstorageSetItem(appApiResources.IsRguest, IsRgueset);
                    this._cs.IsRguest = IsRgueset;
                    
                    this.globalIncSetting(getTenantInfo);
                    
                    that._cs.apiUrl = formDetails.apiUrl;
                    that._cs.rguestLoginUrl = (getTenantInfo.hasOwnProperty('rGuestSSOAuthURL') && getTenantInfo.rGuestSSOAuthURL !== null) ?
                      getTenantInfo.rGuestSSOAuthURL : null;
                    this._cs.RGuestProductId = getTenantInfo.rGuestProductId;
                    this._cs.RGuestTenantCode = getTenantInfo.rGuestTenantCode;
                    this._cs.RGuestTenantId = getTenantInfo.rGuestTenantId;
                    this._cs.IntegrationConfig = getTenantInfo.integrationCofig;
                    
                    localStorage.setItem(appApiResources.RguestLoginURL, that._cs.rguestLoginUrl);
                    localStorage.setItem(appApiResources.RGuestProductId, that._cs.RGuestProductId);
                    localStorage.setItem(appApiResources.RGuestTenantCode, that._cs.RGuestTenantCode);
                    localStorage.setItem(appApiResources.RGuestTenantId, that._cs.RGuestTenantId);
                    localStorage.setItem(appApiResources.IntegrationConfig, that._cs.IntegrationConfig);
                    
                    const windowsOrgin = window.location.origin;
                    const adAureModel = {} as AzureAdModel;
                    const AzureAuthAdType = (adModelObject.hasOwnProperty('AzureAdType')) ? adModelObject.AzureAdType : null;
                    const OAuthSettings = {} as OAuthSettingsConfig;
                    
                    OAuthSettings.appId = adModelObject.ClientId;
                    OAuthSettings.scopes = (AzureAuthAdType !== null && AzureAuthAdType === '2') ? ['openid'] : ['openid', 'profile', 'User.Read', 'offline_access'];
                    
                    const AzureAdType = (adModelObject.hasOwnProperty('AzureAdType')) ? adModelObject.AzureAdType : null;
                    adAureModel.clientID = adModelObject.ClientId;
                    adAureModel.redirectUri = (AzureAdType !== null && AzureAdType === '2') ? `${windowsOrgin}/` + `signin-oidc-${adModelObject.AzureAdB2CSigninOidc}` : `${windowsOrgin}/`;
                    adAureModel.response_mode = MasterData['default'].response_mode;
                    adAureModel.cacheLocation = MasterData['default'].cacheLocation;
                    adAureModel.authority = this._cs.constractAdAuthority(AzureAdType, adModelObject, MasterData);
                    adAureModel.extraQueryParameters = null;
                    adAureModel.protectedResourceMap = MasterData['default'].protectedResourceMap;
                    adAureModel.unprotectedResources = MasterData['default'].unprotectedResources;
                    adAureModel.tenant = adModelObject.TenantId;
                    
                    const adUserFlow: string = adModelObject.AzureAdB2CUserflow ? adModelObject.AzureAdB2CUserflow : adModelObject['AzureADB2CUserflow'];
                    if (AzureAdType !== null && AzureAdType === '2') {
                      adAureModel.signUpSignInPolicy = adUserFlow;
                    }
                    
                    if (adModelObject && adModelObject.ClientId !== null) {
                      window.localStorage.setItem('clientId', adModelObject.ClientId);
                    }
                    
                    const tenantInformation = {} as TenantInformation;
                    tenantInformation.Id = 1;
                    tenantInformation.TenantID = adModelObject.TenantId;
                    tenantInformation.ClientID = adModelObject.ClientId;
                    tenantInformation.ClientSecret = adModelObject.ClientSecret;
                    tenantInformation.AzureAdType = adModelObject.AzureAdType;
                    tenantInformation.AzureADB2CAuthority = adModelObject.AzureADB2CAuthority;
                    tenantInformation.AzureAdB2CUserflow = adUserFlow;
                    
                    this.AzureInfo.tenantInfo = { ...tenantInformation };
                    this.AzureInfo.azureAdInfo = { ...adAureModel };
                    window.localStorage.setItem('adAureModel', JSON.stringify(adAureModel));
                    window.localStorage.setItem('tenantInfo', JSON.stringify(tenantInformation));
                    this.AzureInfo.azureOAuthSettings = { ...OAuthSettings };
                    
                    if (this.csharpService.IsLoadFromApp) {
                      const settingsObj = {
                        apiUrl: formDetails.apiUrl,
                        Tenant: JSON.stringify(getTenantInfo),
                        Modulename: myGlobals.cSharpModuleName.SaveSettings,
                        Action: myGlobals.cSharpModuleName.SaveSettings
                      };
                      this.csharpService.RequestPOSTCSharp(appApiResources.cSharpURLs.StoreTenant, settingsObj);
                    }
                    
                    that.router.navigate(['/login']);
                    that._cs.showSettingToast = true;
                    that._cs.showSettingToastText = that.settingDetails.updateSuccess;
                  }
                } else {
                  localStorage.removeItem('apiUrl');
                  that.showToastMessage(this._ts.instant('setting.toastmsginvalidtenant'));
                }
              } catch (error) {
                console.error('Error updating tenant:', error);
                localStorage.removeItem('apiUrl');
                that.showToastMessage(this._ts.instant('setting.toastmsginvalidtenant'));
              }
              break;
            case 'CANCEL':
              break;
          }
        }
      });
    }
  }

  private globalIncSetting(tenantInfo: any): void {
    try {
      const localCurrencyCode = 'USD';
      
      const defaultDateFormat = tenantInfo.tenantINIConfig?.filter(_ => _.ConfigGroup === 'Formats'
        && _.ConfigKey === 'MobileUILongDateFormat').length > 0 ? tenantInfo.tenantINIConfig.filter(_ => _.ConfigGroup === 'Formats'
          && _.ConfigKey === 'MobileUILongDateFormat')[0].ConfigValue : 'MM/DD/YYYY';
      
      const iniDecimalFormatSetting = '0.00';
      const iniCurrencyFormatSetting = '0.00';
      
      localStorage.setItem(appApiResources.decimalFormat.toString(), iniDecimalFormatSetting);
      localStorage.setItem(appApiResources.currencyFormate.toString(), iniCurrencyFormatSetting);
      localStorage.setItem(appApiResources.dateFormate.toString(), defaultDateFormat);
      localStorage.setItem(appApiResources.CurrencyCode.toString(), localCurrencyCode);
    } catch (error) {
      console.error('Error in GlobalIncSetting:', error);
    }
  }

  showToastMessage(message: string) {
    this.toastShow = true;
    this.toastMessage = message;
  }

  async toastDismissed(event) {
    this.toastShow = false;
    this.toastMessage = '';
  }

  toastAutoDismiss(event) {
    this.toastShow = false;
    this.toastMessage = '';
  }
}
